import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle, Leaf } from 'lucide-react';
export function PricingSection() {
  const benefits = ['Guía completa de estrategias naturales diarias', 'Rutinas de movilidad suaves y efectivas', 'Plan de alimentación antiinflamatoria', 'Acceso a comunidad de apoyo', 'Actualizaciones y nuevos contenidos gratis'];
  return <section id="precio" className="pt-10 pb-24 px-6 bg-sage scroll-mt-8" data-id="element-98">
      <div className="max-w-3xl mx-auto" data-id="element-99">
        <FadeIn data-id="element-100">
          <div className="text-center mb-12" data-id="element-101">
            <Leaf className="w-8 h-8 text-cream mx-auto mb-4 opacity-70" data-id="element-102" />
            <h2 className="text-3xl sm:text-4xl font-serif text-cream mb-4" data-id="element-103">
              Tu plan de bienestar articular
            </h2>
            <p className="text-lg text-cream/80 max-w-xl mx-auto" data-id="element-104">
              Todo lo que necesitas para comenzar tu camino hacia una vida con
              menos dolor y más libertad de movimiento.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-105">
          <div className="bg-white rounded-3xl shadow-md border border-cream overflow-hidden" data-id="element-106">
            {/* Price Header */}
            <div className="bg-sage p-8 sm:p-10 text-center" data-id="element-107">
              <p className="text-cream/80 text-sm font-medium tracking-widest uppercase mb-3" data-id="element-108">
                Oferta especial por tiempo limitado
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-109">
                <span className="text-2xl sm:text-3xl font-serif text-cream/50 line-through" data-id="element-110">
                  $47
                </span>
                <span className="text-cream/50 text-sm" data-id="element-111">USD</span>
              </div>
              <div className="flex items-baseline justify-center gap-2" data-id="element-112">
                <span className="text-5xl sm:text-6xl font-serif text-cream font-semibold" data-id="element-113">
                  $6,99
                </span>
                <span className="text-cream/70 text-lg" data-id="element-114">USD</span>
              </div>
              <p className="text-xl font-semibold text-cream mt-1" data-id="element-115">7 días</p>
              <div className="inline-block bg-terracotta/80 text-cream text-sm font-medium px-4 py-1 rounded-full mt-3" data-id="element-116">
                Ahorras más del 85%
              </div>
              <p className="text-cream/80 mt-3 font-serif italic" data-id="element-117">
                Pago único — sin suscripciones
              </p>
            </div>

            {/* Benefits List */}
            <div className="p-8 sm:p-10" data-id="element-118">
              <ul className="space-y-4 mb-10" data-id="element-119">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-120">
                    <CheckCircle className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-121" />
                    <span className="text-lg text-brown" data-id="element-122">{benefit}</span>
                  </li>)}
              </ul>

              <button className="w-full bg-terracotta hover:bg-terracotta-light text-white py-4 rounded-full text-lg font-medium transition-all duration-300 shadow-sm hover:shadow-md hover:-translate-y-0.5" data-id="element-123">
                Quiero comenzar hoy
              </button>

              <p className="text-center text-brown-light text-sm mt-4" data-id="element-124">
                Garantía de satisfacción de 30 días
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}